<div class="container-fluid">
    <div class="row">
        <div class="col-8">
            <app-pagetitle title="Plans"></app-pagetitle>

        </div>

        <div class="col-4">
            <button class="btn btn-primary btn-sm float-end" (click)="openCreateModal(planModal)">
                <i class="mdi mdi-plus"></i> Add Plan
            </button>
        </div>
    </div>

    <div class="page-content-wrapper">

        <app-loader [loading]="loading"></app-loader>

        <div [class.loading-content]="loading">

            <div class="row">
                <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
                    {{ successMessage }}
                    <button type="button" class="btn-close" (click)="successMessage = ''"></button>
                </div>
                <!-- <div *ngIf="loading" class="text-center">Loading plans...</div> -->
                <div *ngIf="error" class="alert alert-danger" role="alert">{{ error }}</div>
                <div class="row" *ngIf="!loading && plans && plans.length">
                    <div class="col-md-4" *ngFor="let plan of plans">
                        <div class="card shadow-sm border-0 mb-3 plan-card">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-start mb-2">
                                    <img src="assets/icons/icons8-clipboard-100.png" alt="plan" width="40">
                                    <div class="d-flex align-items-center gap-2">

                                        <i class="mdi mdi-pencil fs-5 me-2 cursor-pointer" title="Edit"
                                            (click)="openEditModal(plan, planModal)">
                                        </i>

                                        <div class="form-check form-switch m-0 cursor-pointer">
                                            <input class="form-check-input cursor-pointer" type="checkbox"
                                                [checked]="plan.isActive" (change)="updateStatus($event, plan)"
                                                [ngbTooltip]="plan.isActive ? 'Deactivate Plan' : 'Activate Plan'" />
                                        </div>

                                    </div>
                                </div>

                                <div class="mb-2">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="fs-5 fw-semibold">
                                            {{ plan.name }}
                                            <span class="text-primary ms-2">
                                                ₹{{ plan.price }}
                                            </span>
                                        </div>
                                        <span class="badge small px-2 py-1" [ngClass]="{
      'bg-success-subtle text-success': plan.isActive,
      'bg-secondary-subtle text-muted': !plan.isActive
    }">
                                            {{ plan.isActive ? 'Active' : 'Inactive' }}
                                        </span>

                                    </div>

                                    <small class="text-muted">
                                        {{ plan.description || 'No description available' }}
                                    </small>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-6">
                                        <small class="text-muted">Documents</small><br>
                                        <strong>{{ plan.documents }}</strong>
                                    </div>

                                    <div class="col-6 text-end">
                                        <small class="text-muted">Users</small><br>
                                        <strong>{{ plan.users }}</strong>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <small class="text-muted">Features</small>

                                    <ul class="mt-1 ps-0 mb-0 list-unstyled">
                                        <li *ngFor="let feature of plan.features"
                                            class="d-flex align-items-start small mb-1">

                                            <span class="text-success me-2">✔</span>

                                            <span>{{ feature }}</span>

                                        </li>

                                        <li *ngIf="!plan.features?.length" class="text-muted small">
                                            None
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="card mb-3">
                                <div class="card-body">
                                    <h5 class="card-title">{{ plan.name }} <small class="text-muted">{{ plan.price |
                                            currency }}</small></h5>
                                    <p class="card-text">{{ plan.description }}</p>
                                    <ul class="mb-3">
                                        <li>Documents: {{ plan.documents }}</li>
                                        <li>Users: {{ plan.users }}</li>
                                        <li>Features: {{ plan.features?.join(', ') || 'None' }}</li>
                                    </ul>
                                    <div class="mb-3">
                                        <span class="badge"
                                            [ngClass]="{'bg-success': plan.isActive, 'bg-secondary': !plan.isActive}">{{
                                            plan.isActive ? 'Active' : 'Inactive' }}</span>
                                    </div>
                                    <div class="d-flex gap-2">
                                        <button class="btn btn-sm btn-primary" (click)="openEditModal(plan, planModal)"
                                            [disabled]="!plan.isActive">
                                            <i class="mdi mdi-pencil"></i> Edit
                                        </button>
                                        <button class="btn btn-sm btn-danger" (click)="deactivatePlan(plan)"
                                            *ngIf="plan.isActive">
                                            <i class="mdi mdi-close"></i> Deactivate
                                        </button>
                                    </div>
                                </div>
                            </div> -->
                    </div>
                </div>
                <div *ngIf="!loading && (!plans || plans.length === 0)" class="text-muted">No plans found.</div>
            </div>
        </div>

        <ng-template #planModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{ isEditMode ? 'Edit Plan' : 'Create New Plan' }}</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>
                <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
                <form [formGroup]="planForm">
                    <div class="mb-3">
                        <label class="form-label">Plan Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="name"
                            (keydown)="preventInvalidNameInput($event)" />
                        <div *ngIf="planForm.get('name')?.hasError('required') && planForm.get('name')?.touched"
                            class="text-danger small">Plan name is required.</div>
                        <div *ngIf="planForm.get('name')?.hasError('pattern') && planForm.get('name')?.touched"
                            class="text-danger small">Plan name can contain only alphabets and spaces.</div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Price <span class="text-danger">*</span></label>
                                <input type="number" class="form-control" formControlName="price" min="1" step="1"
                                    (keydown)="preventInvalidInput($event)" />

                                <div *ngIf="planForm.get('price')?.touched && planForm.get('price')?.errors"
                                    class="text-danger small">

                                    <div *ngIf="planForm.get('price')?.errors?.['required']">
                                        Price is required.
                                    </div>

                                    <div *ngIf="planForm.get('price')?.errors?.['min']">
                                        Price must be greater than 0.
                                    </div>

                                    <div *ngIf="planForm.get('price')?.errors?.['max']">
                                        Maximum allowed is 10,00,000.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">
                                    Documents <span class="text-danger">*</span>
                                </label>

                                <input type="number" class="form-control" formControlName="documents" min="1"
                                    (keydown)="preventInvalidInput($event)" />

                                <div *ngIf="planForm.get('documents')?.touched && planForm.get('documents')?.errors"
                                    class="text-danger small">

                                    <div *ngIf="planForm.get('documents')?.errors?.['required']">
                                        Documents count is required.
                                    </div>

                                    <div *ngIf="planForm.get('documents')?.errors?.['min']">
                                        Documents must be greater than 0.
                                    </div>

                                    <div *ngIf="planForm.get('documents')?.errors?.['max']">
                                        Maximum allowed is 5,00,000.
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Users <span class="text-danger">*</span></label>
                                <input type="number" class="form-control" formControlName="users" min="1"
                                    (keydown)="preventInvalidInput($event)" />
                                <div *ngIf="planForm.get('users')?.touched && planForm.get('users')?.errors"
                                    class="text-danger small">

                                    <div *ngIf="planForm.get('users')?.errors?.['required']">
                                        Users count is required.
                                    </div>

                                    <div *ngIf="planForm.get('users')?.errors?.['min']">
                                        Users must be greater than 0.
                                    </div>

                                    <div *ngIf="planForm.get('users')?.errors?.['max']">
                                        Maximum allowed is 1,00,000.
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Active</label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="isActive"
                                        formControlName="isActive" />
                                    <label class="form-check-label" for="isActive">Mark as active</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Description</label>

                        <textarea class="form-control" formControlName="description" rows="2" maxlength="500"
                            (input)="onDescriptionInput()"></textarea>
                        <div class="text-muted small mt-1">
                            {{ charCount }}/500 characters
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Features</label>
                        <div class="d-flex gap-2">
                            <input type="text" class="form-control" [(ngModel)]="featureInput"
                                [ngModelOptions]="{ standalone: true }" placeholder="Enter feature" maxlength="100"
                                (input)="onFeatureInput()" />
                            <div class="text-muted small mt-1">
                                {{ featureCount }}/100 characters
                            </div>
                            <button class="btn btn-primary" type="button" (click)="addFeature()">
                                Add
                            </button>
                        </div>
                        <div *ngIf="featureError" class="text-danger small mt-1">
                            {{ featureError }}
                        </div>

                        <div class="mt-2 d-flex flex-wrap gap-2">
                            <span class="badge bg-secondary d-flex align-items-center"
                                *ngFor="let feature of features; let i = index">
                                {{ feature }}
                                <button type="button" class="btn-close btn-close-white ms-2" (click)="removeFeature(i)">
                                </button>
                            </span>
                        </div>

                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="savePlan()">{{ isEditMode ? 'Update' : 'Create'
                    }}</button>
            </div>
        </ng-template>
    </div>
</div>